module.exports = __webpack_public_path__ + "static/media/icon_safari.2775c1c2.png";